/* Cart: slide-out drawer, AJAX add (DS.add) with one-time free gift, upsells, quantity/remove.
   Drawer: focus trap + Esc + focus return, 8 s timeout (then the cart page), cart count + aria-label kept in sync. */
(function () {
  var DS = (window.DS = window.DS || {});
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = function () { return document.querySelector('[data-ds-drawer]'); };
  var isCartPage = function () { return /\/cart\/?$/.test(location.pathname); };
  var GIFT_KEY = 'ds_gift_v1';
  var opener = null;

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(GIFT_KEY) || 'null');
      localStorage.setItem(GIFT_KEY, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function giftState(token) { var s = store(true); return s && s.token === token ? s.state : ''; }
  function setGiftState(token, state) { store(false, { token: token, state: state }); }

  function updateBubble(count) {
    document.querySelectorAll('[data-ds-cart-count]').forEach(function (n) { var before = parseInt(n.textContent, 10) || 0; n.textContent = count > 0 ? String(count) : ''; n.hidden = !(count > 0); if (count > before) { var a = n.closest('[data-ds-cart-link]') || n; a.classList.remove('ds-bump'); void a.offsetWidth; a.classList.add('ds-bump'); } });
    document.querySelectorAll('[data-ds-cart-link]').forEach(function (a) { a.setAttribute('aria-label', ((DS.t && DS.t.cart) || 'Carrito') + ' (' + (count || 0) + ')'); });
  }

  function timed(promise, ms) {
    return new Promise(function (res, rej) {
      var to = setTimeout(function () { rej(new Error('timeout')); }, ms);
      promise.then(function (v) { clearTimeout(to); res(v); }, function (e) { clearTimeout(to); rej(e); });
    });
  }
  function post(url, body) {
    return timed(fetch(root + url.replace(/^\//, ''), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }), 15000);
  }
  function getCart() { return timed(fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }), 8000).then(function (r) { return r.json(); }); }

  function mountFresh(container, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ds-cart]');
    if (!fresh) return null;
    container.replaceWith(fresh);
    var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    updateBubble(count);
    if (count === 0) { try { localStorage.removeItem(GIFT_KEY); } catch (e) {} }
    if (window.DS && DS.fillEta) DS.fillEta(fresh);
    cleanupGiftOnly(fresh);
    return fresh;
  }

  function render(box) {
    var src = box.getAttribute('data-src');
    box.classList.add('is-busy');
    return timed(fetch(src, { credentials: 'same-origin' }), 8000)
      .then(function (r) { return r.text(); })
      .then(function (html) { return mountFresh(box, html); })
      .catch(function () { box.classList.remove('is-busy'); location.href = root + 'cart'; });
  }

  // if only the free gift is left in the cart, take it out (and allow it again on the next add)
  function cleanupGiftOnly(box) {
    if (!box || box.getAttribute('data-gift-only') !== 'true') return;
    var line = box.querySelector('[data-gift-line]');
    if (!line) return;
    box.classList.add('is-busy');
    post('cart/change.js', { line: parseInt(line.getAttribute('data-line'), 10), quantity: 0 })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setGiftState(cart.token, ''); render(box); });
  }

  function focusables(d) {
    return Array.prototype.filter.call(d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  DS.open = function () {
    var d = drawer();
    if (!d) { location.href = root + 'cart'; return Promise.resolve(); }
    if (!opener) opener = document.activeElement;
    var mount = d.querySelector('[data-ds-cart-mount]');
    d.hidden = false;
    document.documentElement.classList.add('ds-drawer-lock');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    return timed(fetch(root + '?section_id=' + (DS.cartSection || 'ds-cart-drawer'), { credentials: 'same-origin' }), 8000)
      .then(function (r) { if (!r.ok) throw new Error('render'); return r.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        mount.innerHTML = ''; mount.appendChild(holder);
        if (!mountFresh(holder, html)) throw new Error('render');
        var x = d.querySelector('[data-ds-close].ds-cartbody__x'); if (x) x.focus({ preventScroll: true });
      })
      .catch(function () {
        // the drawer could not render (slow network): show the cart page instead of a spinner forever
        location.href = root + 'cart';
        var e = new Error('render'); e.stage = 'render'; throw e;
      });
  };

  DS.close = function () {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('ds-drawer-lock');
    setTimeout(function () { d.hidden = true; }, 280);
    if (opener && opener.focus && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  };

  /* Add items, adding the free gift once per cart on the first add. Resolves after the drawer opens.
     Rejects with err.stage = 'add' (nothing was added) or 'render' (added, drawer failed). */
  var inflight = null;
  DS.add = function (items, opts) {
    if (inflight) return inflight;
    opts = opts || {};
    opener = document.activeElement;
    var giftId = parseInt(DS.giftVariantId, 10) || 0;
    var pre = giftId ? getCart().catch(function () { return null; }) : Promise.resolve(null);
    var addedGift = false, token = null;
    var fail = function (stage) { var e = new Error(stage); e.stage = stage; throw e; };
    inflight = pre.then(function (cart) {
      var withGift = false;
      if (cart && giftId) {
        token = cart.token;
        var has = cart.items.some(function (i) { return i.variant_id === giftId; });
        var st = giftState(token);
        withGift = !has && st !== 'added' && st !== 'removed' && !items.some(function (i) { return +i.id === giftId; });
      }
      var all = items.slice();
      if (withGift) all.push({ id: giftId, quantity: 1 });
      return post('cart/add.js', { items: all }).then(function (r) {
        if (r.ok) { addedGift = withGift; return r.json(); }
        if (withGift) return post('cart/add.js', { items: items }).then(function (r2) { if (!r2.ok) fail('add'); return r2.json(); });
        fail('add');
      }, function () { fail('add'); });
    }).then(function () {
      if (addedGift) setGiftState(token, 'added');
      items.forEach(function (i) { window.dispatchEvent(new CustomEvent('ds:add', { detail: { variant: i.id, quantity: i.quantity, price: opts.price || 0 } })); });
      if (isCartPage()) { var box = document.querySelector('[data-ds-cart]'); if (box) return render(box); }
      return DS.open();
    });
    var clear = function () { inflight = null; };
    inflight.then(clear, clear);
    return inflight;
  };

  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('[data-ds-cart-link]');
    if (cartLink && !isCartPage() && drawer()) { e.preventDefault(); opener = cartLink; DS.open().catch(function () {}); return; }
    if (e.target.closest('[data-ds-close]')) { DS.close(); return; }

    var box = e.target.closest('[data-ds-cart]');
    if (!box) return;
    if (e.target.closest('[data-ds-drawer] a[href]') && !e.target.closest('[data-keep-open]')) { DS.close(); return; }

    var li = e.target.closest('[data-line]');
    var q = e.target.closest('[data-qty]');
    if (q && li) {
      var cur = parseInt(li.getAttribute('data-qty-now'), 10) || 1;
      box.classList.add('is-busy');
      post('cart/change.js', { line: parseInt(li.getAttribute('data-line'), 10), quantity: Math.max(0, cur + parseInt(q.getAttribute('data-qty'), 10)) }).then(function () { render(box); }, function () { render(box); });
      return;
    }
    if (e.target.closest('[data-remove]') && li) {
      box.classList.add('is-busy');
      post('cart/change.js', { line: parseInt(li.getAttribute('data-line'), 10), quantity: 0 })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (li.hasAttribute('data-gift-line')) setGiftState(cart.token, 'removed'); render(box); }, function () { render(box); });
      return;
    }
    if (e.target.closest('[data-bar-checkout]')) { var b = box.querySelector('.ds-sum__checkout'); if (b) b.click(); return; }
    var up = e.target.closest('[data-up-add]');
    if (up) {
      if (up.disabled) return;
      up.disabled = true;
      up.textContent = (DS.t && DS.t.adding) || '…';
      box.classList.add('is-busy');
      post('cart/add.js', { items: [{ id: parseInt(up.getAttribute('data-up-add'), 10), quantity: 1 }] })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          window.dispatchEvent(new CustomEvent('ds:add', { detail: { variant: +up.getAttribute('data-up-add'), quantity: 1, price: +up.getAttribute('data-price') || 0 } }));
          up.textContent = (DS.t && DS.t.added) || 'Añadido';
          return render(box);
        })
        .catch(function () { up.disabled = false; up.textContent = (DS.t && DS.t.error) || 'Error'; box.classList.remove('is-busy'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { DS.close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(d);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { var d = drawer(); if (d) { d.classList.remove('is-open'); d.hidden = true; document.documentElement.classList.remove('ds-drawer-lock'); } } });

  // cart page: also clean a gift-only cart on load
  if (isCartPage()) document.addEventListener('DOMContentLoaded', function () { cleanupGiftOnly(document.querySelector('[data-ds-cart]')); });
})();
